import { c as _c } from "react/compiler-runtime";
import { checkIsInIframe } from '@onefootprint/core';
import { IcoCheckCircle40 } from '@onefootprint/icons';
import { checkIsMobile, HeaderTitle, Logger, NavigationHeader } from '@onefootprint/idv';
import { useFootprintProvider } from '@onefootprint/idv2';
import { Button, LinkButton } from '@onefootprint/ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBifrostMachine } from 'src/components/bifrost-machine-provider';
const AUTO_CLOSE_DELAY = 6000;
const Complete = () => {
  const $ = _c(25);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.complete"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const fpProvider = useFootprintProvider();
  const [state] = useBifrostMachine();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = !checkIsInIframe() && checkIsMobile();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isWebview = t1;
  const {
    idvCompletePayload
  } = state.context;
  let t2;
  if ($[2] !== fpProvider || $[3] !== idvCompletePayload) {
    t2 = delay => {
      Logger.info("IDV flow is complete, sending validation token back to the tenant from Bifrost completion page");
      if (idvCompletePayload?.validationToken) {
        fpProvider.complete({
          validationToken: idvCompletePayload.validationToken,
          deviceResponse: idvCompletePayload.deviceResponseJson,
          authToken: idvCompletePayload.authToken,
          delay
        });
      }
    };
    $[2] = fpProvider;
    $[3] = idvCompletePayload;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleComplete = t2;
  let t3;
  if ($[5] !== handleComplete) {
    t3 = () => {
      if (!isWebview) {
        handleComplete(AUTO_CLOSE_DELAY);
      }
    };
    $[5] = handleComplete;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NavigationHeader leftButton={isWebview ? undefined : {
      variant: "close"
    }} />;
    t6 = !isWebview && <IcoCheckCircle40 color="success" />;
    t7 = <div className="mb-3" />;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = isWebview ? t(_temp) : undefined;
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = isWebview ? t(_temp2) : t(_temp3);
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <HeaderTitle display="flex" flexDirection="column" gap={4} subtitle={t8} title={t9} zIndex={3} />;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== handleComplete || $[20] !== t) {
    t12 = <div className="mt-6 w-full">{isWebview ? <Button fullWidth={true} onClick={() => handleComplete()}>{t(_temp4)}</Button> : <LinkButton onClick={() => handleComplete()}>{t(_temp5)}</LinkButton>}</div>;
    $[19] = handleComplete;
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12) {
    t13 = <div className="h-full w-full flex items-center justify-center flex-col text-center relative">{t5}{t6}{t7}{t10}{t11}{t12}</div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default Complete;
function _temp($) {
  return $.subtitle.webview;
}
function _temp2($_0) {
  return $_0.title.webview;
}
function _temp3($_1) {
  return $_1.title.browser;
}
function _temp4($_2) {
  return $_2.cta.webview;
}
function _temp5($_3) {
  return $_3.cta.browser;
}